export const GENERAL_ENQUIRIES_INBOX_KEY = "general_enquiries";
// An Inbox that a retired Team's creation made keeps the key `team:<id>`.
// Only Release 1 `?team=` links and saved Team choices use it now
// (util/inbox-scope), to find that Inbox.
const TEAM_INBOX_KEY_PREFIX = "team:";

export const teamInboxKey = (teamId: string): string =>
  `${TEAM_INBOX_KEY_PREFIX}${teamId}`;

/**
 * Where a conversation belongs: General Enquiries and the Inboxes made in
 * Settings → Inboxes (see managed-inbox-domain).
 */
export default class InboxDomain {
  id: string;

  key: string;

  name: string;

  isActive: boolean;

  constructor(id: string, key: string, name: string, isActive: boolean) {
    this.id = id;
    this.key = key;
    this.name = name;
    this.isActive = isActive;
  }

  isGeneralEnquiries(): boolean {
    return this.key === GENERAL_ENQUIRIES_INBOX_KEY;
  }
}
